import { render, staticRenderFns } from "./explainType.vue?vue&type=template&id=5b986d4e&scoped=true&"
import script from "./explainType.vue?vue&type=script&lang=js&"
export * from "./explainType.vue?vue&type=script&lang=js&"
import style0 from "./explainType.vue?vue&type=style&index=0&id=5b986d4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b986d4e",
  null
  
)

export default component.exports